import React from 'react'
import styled from 'styled-components'
import { IEntriesKnisotItem } from '../../../modules/API/Knisot/models/entrie'
import ControlSearchPannelLayout from '../../Layouts/Wrappers/ControlSearchPannelLayout'
import SearchInput from '../../inputs/inputSearch'
import CircleActiveFilterBtn from '../../particles/CircleActiveFilterBtn'
import PlusIcon from '../../icons/IconLib/PlusIcon'
import CustomBlockLoader from '../../../main/second/mainbar/knisot/generic/CustomBlockLoader'
import useEntryPallets from './hooks/useEntryPallets'
import PalletGroupCard from './components/PalletGroupCard'
import PalletDetailDrawer from './components/PalletDetailDrawer'

type Props = {
  entryItem: IEntriesKnisotItem
  closeFunc?: () => void
}

const EntryPalletsModal = ({ entryItem }: Props) => {
  const {
    isLoading,
    error,
    palletGroups,
    searchQuery,
    setSearchQuery,
    drawerState,
    handleRowClick,
    handleOpenCreate,
    handleCloseDrawer,
    handleCreate,
    handleUpdate,
  } = useEntryPallets(entryItem)

  if (error) {
    return <ErrorMessage>{error}</ErrorMessage>
  }

  return (
    <ModalWrapper>
      <ControlSearchPannelLayout>
        <SearchInput
          input={searchQuery}
          setInput={setSearchQuery}
          value="חיפוש לפי מוצר"
        />
        <CircleActiveFilterBtn func={handleOpenCreate} aria-label="צור תעודה חדשה">
          <PlusIcon />
        </CircleActiveFilterBtn>
      </ControlSearchPannelLayout>

      {isLoading ? (
        <CustomBlockLoader />
      ) : palletGroups.length === 0 ? (
        <EmptyMessage>אין משטחים לשורה זו</EmptyMessage>
      ) : (
        <GroupsList>
          {palletGroups.map((group) => (
            <PalletGroupCard key={group.palletNum} group={group} onRowClick={handleRowClick} />
          ))}
        </GroupsList>
      )}

      <PalletDetailDrawer
        drawerState={drawerState}
        onClose={handleCloseDrawer}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
      />
    </ModalWrapper>
  )
}

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const GroupsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6em;
  overflow-y: auto;
  padding: 0 0.3em 1em;

  &::-webkit-scrollbar {
    width: 0;
  }
`

const ErrorMessage = styled.p`
  text-align: center;
  color: tomato;
  font-size: 0.9rem;
  padding: 2em 0;
`

const EmptyMessage = styled.p`
  text-align: center;
  color: #8a9ab0;
  font-size: 0.9rem;
  padding: 2em 0;
`

export default EntryPalletsModal
